import React, { useEffect, useRef, useState } from 'react';
import './Footer.css';
import { useTranslation } from 'react-i18next';

import Logo from '../../assets/image/footer-logo.svg';

const Footer = () => {
  const { t } = useTranslation();
  const [showForm, setShowForm] = useState(false);
  const footerRef = useRef(null);
  const prevScrollY = useRef(0);

  const checkScrollPosition = () => {
    const isMobile = window.innerWidth <= 700;
    const footerBtn = document.querySelector('.footer__get-projects');
    const scrollY = window.scrollY;

    if (!footerRef.current) return;

    const rect = footerRef.current.getBoundingClientRect();
    const footerBottomVisible = rect.bottom <= window.innerHeight;

    if (isMobile) {
      if (footerBottomVisible) {
        setShowForm(true);
        footerBtn?.classList.add('scroll');
      } else if (scrollY < prevScrollY.current) {
        setShowForm(false);
        footerBtn?.classList.remove('scroll');
      }
    } else {
      const scrollPosition = scrollY + window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      if (scrollPosition >= documentHeight - 10) {
        setShowForm(true);
        footerBtn?.classList.add('scroll');
      } else if (scrollY < prevScrollY.current) {
        setShowForm(false);
        footerBtn?.classList.remove('scroll');
      }
    }

    prevScrollY.current = scrollY;
  };

  useEffect(() => {
    window.addEventListener('scroll', checkScrollPosition);
    return () => {
      window.removeEventListener('scroll', checkScrollPosition);
    };
  }, []);
  return (
    <footer className="footer">
      <div className="footer__container container">
        <a href="/" className="footer__link" ref={footerRef}>
          <img src={Logo} alt="" className="footer__logo" />
        </a>

        <div className="footer__wrapper">
          <div className="footer__products">
            <ul className="footer__list">
              <li className="footer__item">
                <p className="footer__name">{t('about')}</p>
              </li>
              <li className="footer__item">
                <p className="footer__description">
                  {t('serendix_description')}
                </p>
              </li>
            </ul>
          </div>
          <div className="footer__page ft-link">
            <ul className="footer__list">
              <li className="footer__item">
                <p className="footer__name"> {t('link')}</p>
              </li>
              <li className="footer__item ft-link__item">
                <a href="/about" className="footer__link">
                  {t('about')}
                </a>
              </li>
              <li className="footer__item ft-link__item">
                <a href="/services" className="footer__link">
                  {t('services')}
                </a>
              </li>
              <li className="our-products__item ft-link__item">
                <a href="/cases" className="footer__link">
                  {t('cases')}
                </a>
              </li>
            </ul>
          </div>
          <div className="footer__contacts contscts-us">
            <ul className="footer__list">
              <li className="our-products__item">
                <p className="footer__name"> {t('contact_us')}</p>
              </li>
              <li className="our-products__item">
                <a href="+38 (063) 397 19 99" className="footer__link">
                  {t('tel')}: +380956584268
                </a>
              </li>
            </ul>
            <ul className="footer__list footer__social-row">
              <li>
                <a
                  href="https://wa.me/380956584268"
                  target="_blank"
                  rel="noopener"
                  className="ft-socil-row__link"
                  aria-label="WhatsApp"
                >
                  <svg
                    width="24"
                    height="24"
                    fill="#00AEEF"
                    viewBox="0 0 24 24"
                  >
                    <path d="M12 2C6.48 2 2 6.48 2 12A9.96 9.96 0 0 0 3.56 17.33L2 22L6.67 20.44A9.96 9.96 0 0 0 12 22C17.52 22 22 17.52 22 12S17.52 2 12 2ZM17 14.09C16.18 14.09 15.37 13.95 14.61 13.68C14.24 13.56 13.81 13.67 13.55 13.94L12.46 15.03C10.32 14.03 9.07 12.78 8.06 10.64L9.15 9.55C9.41 9.29 9.52 8.86 9.4 8.49A10.75 10.75 0 0 1 9 6.11C9 5.5 8.5 5 7.89 5H6C5.45 5 5 5.45 5 6C5 11.52 9.48 16 15 16C15.55 16 16 15.55 16 15V13.11C16 12.5 15.5 12 14.89 12Z" />
                  </svg>
                </a>
              </li>

              <li>
                <a
                  href="https://www.instagram.com/serendix_company/"
                  target="_blank"
                  rel="noopener"
                  className="ft-socil-row__link"
                  aria-label="Instagram"
                >
                  <svg
                    width="24"
                    height="24"
                    fill="#00AEEF"
                    viewBox="0 0 24 24"
                  >
                    <path d="M7.75 2h8.5A5.75 5.75 0 0 1 22 7.75v8.5A5.75 5.75 0 0 1 16.25 22h-8.5A5.75 5.75 0 0 1 2 16.25v-8.5A5.75 5.75 0 0 1 7.75 2Zm0 1.5A4.25 4.25 0 0 0 3.5 7.75v8.5A4.25 4.25 0 0 0 7.75 20.5h8.5A4.25 4.25 0 0 0 20.5 16.25v-8.5A4.25 4.25 0 0 0 16.25 3.5h-8.5Zm4.25 3.25a5.25 5.25 0 1 1 0 10.5a5.25 5.25 0 0 1 0-10.5Zm0 1.5a3.75 3.75 0 1 0 0 7.5a3.75 3.75 0 0 0 0-7.5Zm5.25-.75a.75.75 0 1 1 0 1.5a.75.75 0 0 1 0-1.5Z" />
                  </svg>
                </a>
              </li>

              <li>
                <a
                  href="https://twitter.com/"
                  target="_blank"
                  rel="noopener"
                  className="ft-socil-row__link"
                  aria-label="Twitter"
                >
                  <svg
                    width="24"
                    height="24"
                    fill="#00AEEF"
                    viewBox="0 0 24 24"
                  >
                    <path d="M23 3A10.9 10.9 0 0 1 19.54 4.84A4.48 4.48 0 0 0 12 9.75V10A10.66 10.66 0 0 1 3 4A4.48 4.48 0 0 0 5.47 13.78A4.52 4.52 0 0 1 2 12.88V13A4.48 4.48 0 0 0 6.68 17.29A4.48 4.48 0 0 1 2 18.92A9 9 0 0 0 14 21A12.94 12.94 0 0 1 3 23.47A18 18 0 0 0 10 25C21 25 23 15.5 23 9V8.5A10.27 10.27 0 0 0 24 5.5A10.9 10.9 0 0 1 23 3Z" />
                  </svg>
                </a>
              </li>

              <li>
                <a
                  href="https://www.linkedin.com/in/serendix-company-598099363/"
                  target="_blank"
                  rel="noopener"
                  className="ft-socil-row__link"
                  aria-label="LinkedIn"
                >
                  <svg
                    width="34"
                    height="34"
                    fill="#00AEEF"
                    viewBox="0 0 24 24"
                  >
                    <path d="M4.98 3.5A1.5 1.5 0 1 1 8 3.5A1.5 1.5 0 0 1 4.98 3.5ZM4 6H8V18H4V6ZM10 6H14V8.17C14.59 7.3 15.56 6.67 16.75 6.67C19.1 6.67 20 8.32 20 10.56V18H16V11.22C16 9.86 15.46 9.17 14.52 9.17C13.37 9.17 13 10.05 13 11.21V18H10V6Z" />
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className={`footer__form ${showForm ? 'show' : ''}`}>
          <p className="footer__name">{t('have_a_question')}</p>
          <form className="form-block">
            <input
              type="text"
              placeholder="Name"
              className="form__input"
              required
            />
            <input
              type="email"
              placeholder="Email"
              className="form__input"
              required
            />
            <textarea
              placeholder="Message"
              className="form__textarea"
              rows="3"
              required
            />
            <button type="submit" className="form__button">
              {t('send')}
            </button>
          </form>
        </div>
        <p className="footer__bottom-des">
          2025 © Serendix. All rights reserved
        </p>
      </div>
      <a
        href="https://t.me/Serendix_company"
        className={`footer__get-projects ${showForm ? 'show' : ''}`}
        id="get-projects"
      >
        <div className="get-projects__btn get-projects-btn">
          <span className="get-projects-btn__name">{t('get_projects')}</span>
        </div>
      </a>
    </footer>
  );
};

export default Footer;
